import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { defaultStyles, overrides } from './defaults';

const theme = responsiveFontSizes(
  createMuiTheme({ ...defaultStyles, ...overrides })
);

export default theme;
